import React, { Component } from 'react'
import axios from 'axios'

import Eier from './Eier.jsx'
import EierforholdList from './EierforholdList.jsx';
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import BorettList from './BorettList.jsx';

class EierDetails extends Component {
    state = {
        eier: null
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (this.state.eier == null) return
        if (nextProps.eierId == this.state.eier.eierId) return

        this.setState({eier: null})
    }

    componentDidMount = () => {
        this.getEier()
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        var currentEierId = null;
        if (this.state.eier != null) currentEierId = this.state.eier.eierId

        var nextEierId = null
        if (nextState.eier != null) nextEierId = nextState.eier.eierId

        if (currentEierId != nextEierId) return true
        return false
    }

    componentDidUpdate = () => {
        if (this.state.eier == null || this.state.eier.eierId != this.props.eierId) this.getEier()
    }

    getEier = () => {
        axios.get(`${this.props.settings.baseUrl}api/eier/${this.props.eierId}`, {
            params: {
                token: this.props.token
            }
        })
        .then(({data}) => {
            this.setState({eier: data})
            this.props.onEvent({
                type: MatrikkelSearchEvents.SelectEier,
                data: {
                    eier: data
                }
            })
        })
      }

    render() {
        if (this.state.eier == null) return (<div className="spinner"><i className="fa fa-spinner fa-spin"></i></div>)
        var eier = this.state.eier
        return (
            <ul className="resultdetails">
                <Eier eier={eier} token={this.props.token} onEvent={this.props.onEvent} />
                { eier.antallEierforhold > 0 && <EierforholdList eierId={eier.eierId} antall={eier.antallEierforhold} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} /> }
                { this.props.settings.hasGrunnbok && this.props.settings.hasEier && eier.antallBoretter > 0 && <BorettList eierId={eier.eierId} antall={eier.antallBoretter} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} /> }
            </ul>
        )
    }
}

export default EierDetails